var _a, _b;
import getConfig from 'next/config';
const isNextJs = (_b = (_a = getConfig()) === null || _a === void 0 ? void 0 : _a.publicRuntimeConfig) === null || _b === void 0 ? void 0 : _b.isNextJs;
let defaultExport;
if (isNextJs) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    defaultExport = require('./pwa_config').default;
}
else {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    defaultExport = require('./fwn_config').default;
}
export default defaultExport;
